var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-wrapper',{attrs:{"instance":_vm.instance}},[_c('MgsExpander',[_c('template',{slot:"head"},[_vm._v(_vm._s(_vm.instance.buttonText))])],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("More Information Content")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }